export default "__VITE_ASSET__DvBgSQtD__"